const SILENT_AUTH_ERROR_PARAM = 'central_auth_error';
const SILENT_AUTH_SUCCESS_PARAM = 'central_auth_success';
const SILENT_AUTH_ERROR_DESCRIPTION_PARAM = 'error_description';

export const hasSilentAuthLoginRequiredError = (searchParams: URLSearchParams): boolean => Boolean(searchParams.get(SILENT_AUTH_ERROR_PARAM));

export const hasSilentAuthSuccess = (searchParams: URLSearchParams): boolean => Boolean(searchParams.get(SILENT_AUTH_SUCCESS_PARAM));

export const removeSilentAuthParams = (searchParams: URLSearchParams): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(searchParams.toString());
  nextSearchParams.delete(SILENT_AUTH_ERROR_PARAM);
  nextSearchParams.delete(SILENT_AUTH_ERROR_DESCRIPTION_PARAM);
  nextSearchParams.delete(SILENT_AUTH_SUCCESS_PARAM);
  return nextSearchParams;
};

export const getCleanedUrlFromSearchParams = ({
  pathname,
  hash,
  searchParams,
}: {
  pathname: string;
  hash: string;
  searchParams: URLSearchParams;
}): string => {
  const cleanedSearchParams = removeSilentAuthParams(searchParams);
  const search = cleanedSearchParams.toString();
  return `${pathname}${search ? `?${search}` : ''}${hash}`;
};
